import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import SrTourDate from 'client/components/SrTourDate';

import {
  TOUR_STATUS_REQUESTED,
  TOUR_STATUS_SCHEDULED,
  TOUR_TYPE_SELF_SHOWING,
} from 'common/tourConstants';

@withRouter
class SrTourUpcomingStatus extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    onRescheduleTour: PropTypes.func.isRequired,
  };

  _onClickRescheduleTour = () => {
    const { onRescheduleTour, tour, history } = this.props;
    if (tour.markedNeedsReschedulingFlag) {
      history.push(`/tour/${tour.id}/${tour.listings[0].id}/choose-tour-time`);
    } else {
      onRescheduleTour({ tour });
    }
  };

  _onCancelTour = () => {
    const { tour, history } = this.props;
    history.push(`/tour/${tour.id}/cancel`);
  };

  render() {
    const { tour } = this.props;

    const initialListing = tour.listings[0];
    const tourAgentUserName = tour.agentUserName;

    const currentStatusIsRequested = tour.status === TOUR_STATUS_REQUESTED;
    const currentStatusIsScheduled = tour.status === TOUR_STATUS_SCHEDULED;

    if (tour.markedNeedsReschedulingFlag) {
      return null;
    }

    return (
      <div className="tourStatusContainer">
        <div className="tourTimeContainer">
          <SrTourDate tour={tour} />
          {tour.type !== TOUR_TYPE_SELF_SHOWING && (
            <span
              onClick={this._onClickRescheduleTour}
              className="blue-bright weight-medium float-right cursor-pointer"
            >
              Reschedule
            </span>
          )}
        </div>
        {tour.markedNeedsReschedulingFlag ? (
          <div className="step noBadge">
            <div className="title">
              <span>Change your mind?</span>
            </div>
            <span>
              {'You had requested to see the following ' +
                `${pluralize('rental', tour.listings.length)} on your last visit. ` +
                'If you\'d still like to see them, click "Reschedule".'}
            </span>
          </div>
        ) : (
          <span>
            <div className="step done">
              <div className="title">
                <span>Requested</span>
              </div>
              {currentStatusIsRequested && (
                <span>
                  {`We're checking to see if the ${pluralize('home', tour.listings.length)} ` +
                    'can be seen at this time.\n' +
                    `We'll let you know once ${tour.listings.length > 1 ? 'they are' : "it's"} ` +
                    'confirmed!'}
                </span>
              )}
            </div>
            <div
              className={classNames('step', {
                disabled: currentStatusIsRequested,
              })}
            >
              <div className="title">
                <span>Confirmed</span>
              </div>
              {currentStatusIsScheduled && (
                <span>
                  Meet with {tourAgentUserName ? `${tourAgentUserName},` : ''} your Sunroom tour
                  guide, starting at{' '}
                  {initialListing.apartmentName || initialListing.addressStreetDisplay}.
                </span>
              )}
            </div>
            <div className="step disabled">
              <div className="title">
                <span>Completed</span>
              </div>
            </div>
          </span>
        )}
      </div>
    );
  }
}

SrTourUpcomingStatus.displayName = 'SrTourUpcomingStatus';

export default SrTourUpcomingStatus;
